import { useCallback, useEffect, useState } from 'react';

import { Api } from '../../api/api';

import { reportAccessDeniedInChildMode } from '../ChildHome/useChildHome';

import type { IslandState } from './IslandState';

/** Mirrors android/…/Screens/Island/IslandViewModel.kt. */
export function useIsland() {
  const [state, setState] = useState<IslandState>({
    isLoading: true,
    island: null,
    unlockingCode: null,
    error: null,
  });

  const load = useCallback(async (): Promise<void> => {
    setState((current) => ({ ...current, isLoading: true, error: null }));

    const result = await Api.readIsland();

    if (result.ok) {
      setState((current) => ({ ...current, isLoading: false, island: result.value }));

      return;
    }

    const isRoutingDefect = result.error.kind === 'accessDenied';

    if (isRoutingDefect) reportAccessDeniedInChildMode('island');

    setState((current) => ({
      ...current,
      isLoading: false,
      error: isRoutingDefect ? null : result.error.message,
    }));
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    state,
    load,

    unlock: async (partCode: string): Promise<void> => {
      setState((current) => ({ ...current, unlockingCode: partCode, error: null }));

      const result = await Api.unlockIslandPart(partCode);

      setState((current) =>
        result.ok
          ? { ...current, unlockingCode: null, island: result.value }
          : { ...current, unlockingCode: null, error: result.error.message },
      );
    },
  };
}
